import { Affix, Button, Card, Form, Space } from "antd";
import { isMobileView } from "components/Common/AppHelper";
import Header from "components/Common/Header";
import { useNavigate } from "react-router-dom";
import BgmeaUdExportPermissionCostForm from "../BgmeaUdExportPermissionCostForm";

const AddBgmeaUdExportPermissionCost = (props) => {
  const { width } = props;
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const discardForm = () => {
    navigate("/import-export-expense-tracking/bgmea-ud-export-permission-cost");
  };

  const addBgmeaUdExportPermissionCost = () => {
    form.submit();
  };

  const ActionUI = () => {
    return (
      <Space>
        <Button size="small" key={1} danger onClick={() => discardForm()}>
          Discard
        </Button>

        <Button
          size="small"
          key={2}
          type="primary"
          onClick={() => addBgmeaUdExportPermissionCost()}
        >
          Add BGMEA UD Export Permission Cost
        </Button>
      </Space>
    );
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card
          className="p-fixed"
          style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}
        >
          <Header
            title="Add BGMEA UD Export Permission Cost"
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={<ActionUI />}
          />
        </Card>
      </Affix>

      <BgmeaUdExportPermissionCostForm form={form} isEdit={false} />
    </>
  );
};

export default AddBgmeaUdExportPermissionCost;
